import { z } from 'zod/mini'

export const envSchema = z.object({
  VITE_API_BASE: z.url(),
  VITE_VAPID_PUBLIC_KEY: z.string(),
  VITE_STRIPE_PUBLIC_KEY: z.string(),
  VITE_FREE_PLAN_ID: z.coerce.number(),
  VITE_EDGE_BASE: z.url(),
  VITE_PULL_BATCH_SIZE: z._default(z.coerce.number(), 50),
  VITE_PUSH_BATCH_SIZE: z._default(z.coerce.number(), 30),
  VITE_TURNSTILE_SITEKEY: z.string(),
  VITE_PUSH_PROMPT_DELAY_MINUTES: z._default(z.coerce.number(), 5),
  VITE_DEFAULT_SNOOZE_DELAY_DAYS: z._default(z.coerce.number().check(z.minimum(1)), 7),
  VITE_NGROK_URL: z.optional(z.url()),
})
